import { render, staticRenderFns } from "./AtividadeForm.vue?vue&type=template&id=41811f58&"
import script from "./AtividadeForm.vue?vue&type=script&lang=js&"
export * from "./AtividadeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports